import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import { useForm } from "../../../provider/Form/FormProvider";
import ButtonLoading from "../../Button/ButtonLoading";
import Address from "../Common/Address/Address";
import { Person as PersonType } from "../../../types/Entities/Person";
import Person from "../Common/Person/Person";

type PersonsDataProps = {
  collectionName: "additionalOpposingParties";
  withAddress?: boolean;
};

export default function PersonsData({ collectionName, withAddress = true }: PersonsDataProps) {
  const { values, handleChange } = useForm();
  const [isLoading, setIsLoading] = useState(false);
  const persons: PersonType[] = Array.isArray(values[collectionName]) ? values[collectionName] : [];

  //if no persons exist, add one by default
  useEffect(() => {
    if (persons.length === 0) {
      const initialPerson = {
        gender: "",
        givenName: "",
        familyName: "",
      };

      handleChange({
        target: { name: collectionName, value: [initialPerson] },
      });
    }
  }, []);

  const handleAddPerson = () => {
    setIsLoading(true);

    const newPerson = {
      gender: "",
      givenName: "",
      familyName: "",
    };

    const updatedList = [...persons, newPerson];
    handleChange({
      target: { name: collectionName, value: updatedList },
    });
    setIsLoading(false);
  };

  const handleRemoveLastPerson = () => {
    if (persons.length === 0) {
      return;
    }

    setIsLoading(true);

    const lastPerson = persons[persons.length - 1];
    const removeListName = `${collectionName}ToBeRemoved`;

    if (lastPerson.id) {
      values[removeListName].push(lastPerson.id);
    }

    const updatedList = persons.slice(0, -1);
    handleChange({
      target: { name: collectionName, value: updatedList },
    });
    setIsLoading(false);
  };

  return (
    <>
      {persons.map((person: PersonType, index: number) => (
        <React.Fragment key={person.id || index}>
          <Person
            path={`${collectionName}.${index}`}
            headline={`Bitte machen Sie hier weitere Angaben zu der ${index + 2}. Person, mit der Sie den Mietvertrag geschlossen haben`}
            fieldsAreRequired={true}
          />
          {withAddress && <Address path={`${collectionName}.${index}.address`} headline="" fieldsAreRequired={true} />}
        </React.Fragment>
      ))}
      <hr />
      <Grid
        container
        sx={{
          justifyContent: "center",
          alignItems: "baseline",
          marginTop: "2rem",
          marginBottom: "2rem",
          gap: 2
        }}>
        <Grid size={5}>
          <ButtonLoading variant={"text"} fullWidth isLoading={isLoading} onClick={handleRemoveLastPerson} disabled={persons.length <= 1}>
            Letzte Person entfernen
          </ButtonLoading>
        </Grid>
        <Grid size={5}>
          <ButtonLoading variant={"contained"} color={"primary"} fullWidth isLoading={isLoading} onClick={handleAddPerson}>
            Weitere Person hinzufügen
          </ButtonLoading>
        </Grid>
      </Grid>
    </>
  );
}
